export const DEFAULT_CENTER = {
  lat: 40.7237,
  lng: -73.9898
}

export const getNumberOrDefault = (number, isLatitude = false) => {
  if (typeof number === 'number') return number
  if (isLatitude) return DEFAULT_CENTER.lat

  return DEFAULT_CENTER.lng
}

const markerToBounds = marker => ({
  lat: marker.latitude,
  lng: marker.longitude
})

export const markerToBoundsWithDefaults = marker => ({
  lat: getNumberOrDefault(marker.latitude, true),
  lng: getNumberOrDefault(marker.longitude)
})

export const findExtremePoints = coordinates => {
  if (coordinates.length === 0) {
    return null // Return null if the array is empty
  }

  let mostNorthEastern = markerToBounds(coordinates[0])
  let mostSouthWestern = markerToBounds(coordinates[0])

  for (let i = 1; i < coordinates.length; i++) {
    const currentCoord = coordinates[i]

    // Update most north-eastern point
    if (
      currentCoord.latitude > mostNorthEastern.lat ||
      (currentCoord.latitude === mostNorthEastern.lat &&
        currentCoord.longitude > mostNorthEastern.lng)
    ) {
      mostNorthEastern = markerToBounds(currentCoord)
    }

    // Update most south-western point
    if (
      currentCoord.latitude < mostSouthWestern.lat ||
      (currentCoord.latitude === mostSouthWestern.lat &&
        currentCoord.longitude < mostSouthWestern.lng)
    ) {
      mostSouthWestern = markerToBounds(currentCoord)
    }
  }

  return { mostNorthEastern, mostSouthWestern }
}
